// extracted by mini-css-extract-plugin
export default {"wrapper":"simple-container_wrapper__aJ9n6"};